export const EDIT_SCOPES = {
  ALL: 'all',
  CHART: 'chart'
} as const

export type EditScope = (typeof EDIT_SCOPES)[keyof typeof EDIT_SCOPES]
